import { useEffect, useState } from "react"
import UsersTable from "./UsersTable"
import { Button, Form, Image, Pagination } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import {
    addAgency,
    editAgency,
    exportAgencies,
    getAgenciesByPagination,
    getAgencyById,
    getAgencyList,
    searchAgenciesByPagination
} from "../../../data/agencySlice"
import AddEditAgency from "./AddEditAgency"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { css } from "@emotion/react"
import InformationModal from "./InformationModal"
import Loader from "../../../components/Loader"
import { downloadFile } from "../../../constant/utils"
import { useNavigate } from "react-router-dom"
import { byPrefixAndName } from "@awesome.me/kit-de80aecb6a/icons"
const componentStyle = css`
    h2 {
        color: #fff;
    }

    .pagination {
        display: flex;
        justify-content: end;
    }

    .pagination .page-item.active .page-link {
        background-color: #0b274b;
    }

    .pagination .page-item .page-link {
        border-radius: 0 !important;
    }
`
const AgenciesAndContact = () => {
    const [sectionsOpen, setSectionsOpen] = useState([])
    const [showAddAgency, setShowAddAgency] = useState(false)
    const [showAddEditUser, setShowAddEditUser] = useState(false)
    const [currentUser, setCurrentUser] = useState()
    const [contactAgencyId, setContactAgencyId] = useState("")
    const [currentAgency, setCurrentAgency] = useState()
    const [activePage, setActivePage] = useState(0)
    const [search, setSearch] = useState("")
    const [showInformation, setShowInformation] = useState({ show: false, information: {} })
    const [isSearched, setIsSearched] = useState(false)
    const [searchIn, setSearchIn] = useState("Brokerage")

    const dispatch = useDispatch()
    const { data: agencies, fetchStatus, totalRecords, agencyList } = useSelector((state) => state.agency)
    const { fetchStatus: contactFetchStatus } = useSelector((state) => state.contact)

    const numberOfRecordsPerPage = 25
    const totalPages = Math.ceil(totalRecords / numberOfRecordsPerPage)

    useEffect(() => {
        getAgenciesList().then(() => {
            !agencyList.length && dispatch(getAgencyList())
        })
    }, [])

    const toggleSection = (index) => {
        setSectionsOpen((prevState) => {
            const updatedSections = [...prevState]
            updatedSections[index] = !updatedSections[index]
            return updatedSections
        })
    }

    const handleEditAgency = (agency) => {
        dispatch(getAgencyById(agency.id)).then(({ payload }) => {
            if (payload) {
                setCurrentAgency(payload)
                setShowAddAgency(true)
            }
        })
    }

    // Function to handle page change
    const handlePageChange = (index) => {
        if (index >= 0) {
            if (index === activePage) return
            setActivePage(index)
            if (isSearched) {
                handleSearch(index + 1)
            } else {
                getAgenciesList(index + 1, true)
            }
        }
    }

    const getAgenciesList = (pageIndex = 1, isPaginationHappening = false) => {
        if (isSearched) {
            setIsSearched(false)
            setSearch("")
        }
        if (!isPaginationHappening) setActivePage(0)
        return dispatch(
            getAgenciesByPagination({
                pageIndex,
                numberOfRecords: numberOfRecordsPerPage,
                orderBy: "name",
                parentDescending: false,
                childDescending: false
            })
        )
    }

    useEffect(() => {
        setSectionsOpen(Array(agencies?.length).fill(false))
    }, [agencies?.length, activePage])

    const saveAgency = () => {
        if (!!currentAgency?.id) {
            dispatch(editAgency({ ...currentAgency })).then(({ payload }) => {
                if (payload?.succeeded) {
                    getAgenciesList().then(() => {
                        setShowAddAgency(false)
                    })
                } else {
                    setShowAddAgency(false)
                }
            })
        } else {
            dispatch(addAgency({ ...currentAgency })).then(({ payload }) => {
                if (payload?.succeeded) {
                    getAgenciesList().then(() => {
                        setShowAddAgency(false)
                    })
                } else {
                    setShowAddAgency(false)
                }
            })
        }
    }

    const handleSearch = (pageIndex = 1) => {
        if (search) {
            dispatch(
                searchAgenciesByPagination({
                    searchTerm: search,
                    searchIn,
                    pageIndex: pageIndex,
                    numberOfRecords: numberOfRecordsPerPage,
                    orderBy: "name",
                    parentDescending: false,
                    childDescending: false
                })
            ).then(() => {
                if (!isSearched) setIsSearched(true)
            })
        }
        if (search === "") {
            getAgenciesList()
        }
    }

    const handleExportAll = () => {
        dispatch(exportAgencies()).then(({ payload: { file, fileName, mimeType } }) => {
            if (file) {
                downloadFile({
                    file,
                    fileName,
                    mimeType
                })
            }
        })
    }

    const handleShowInformation = (id, type) => {
        if (type === "agency") {
            dispatch(getAgencyById(id)).then(({ payload }) => {
                if (payload) {
                    setShowInformation({ show: true, information: { informationType: "Agency", data: payload } })
                }
            })
        } else {
            let user = {}
            agencies.forEach((agency) => {
                agency.contacts.filter((u) => {
                    if (u.id === id) {
                        user = u
                        let updatedUser = { ...user }
                        updatedUser.agency = agency.name
                        user = updatedUser
                        return true
                    }
                    return false
                })
            })
            setShowInformation({ show: true, information: { informationType: "Agency Contact", data: user } })
        }
    }

    const renderPagination = () => {
        const paginationItems = []
        const ellipsis = (
            <Pagination.Ellipsis
                key="ellipsis"
                disabled
            />
        )
        const pagesToShow = 5 // Number of pages to show in the middle
        const tailPagesToShow = 2 // Number of pages to show at the end

        // Add First and Previous Buttons
        paginationItems.push(
            <Pagination.First
                key="first"
                onClick={() => handlePageChange(0)}
                disabled={activePage === 0}
            />
        )
        paginationItems.push(
            <Pagination.Prev
                key="prev"
                onClick={() => handlePageChange(activePage - 1)}
                disabled={activePage === 0}
            />
        )

        if (totalPages <= pagesToShow + tailPagesToShow) {
            // If total pages are small, show all pages
            for (let i = 0; i < totalPages; i++) {
                paginationItems.push(
                    <Pagination.Item
                        key={i}
                        onClick={() => handlePageChange(i)}
                        active={activePage === i}>
                        {i + 1}
                    </Pagination.Item>
                )
            }
        } else {
            // Show first page
            paginationItems.push(
                <Pagination.Item
                    key={0}
                    onClick={() => handlePageChange(0)}
                    active={activePage === 0}>
                    {1}
                </Pagination.Item>
            )

            // Determine start and end of the middle range
            const startPage = Math.max(1, activePage - Math.floor((pagesToShow - 1) / 2))
            const endPage = Math.min(totalPages - tailPagesToShow, startPage + pagesToShow - 1)

            // Add ellipsis before middle pages if needed
            if (startPage > 1) {
                paginationItems.push(ellipsis)
            }

            // Add middle pages
            for (let i = startPage; i < endPage; i++) {
                paginationItems.push(
                    <Pagination.Item
                        key={i}
                        onClick={() => handlePageChange(i)}
                        active={activePage === i}>
                        {i + 1}
                    </Pagination.Item>
                )
            }

            // Add ellipsis after middle pages if needed
            if (endPage < totalPages - tailPagesToShow) {
                paginationItems.push(ellipsis)
            }

            // Show last few pages
            for (let i = totalPages - tailPagesToShow; i < totalPages; i++) {
                paginationItems.push(
                    <Pagination.Item
                        key={i}
                        onClick={() => handlePageChange(i)}
                        active={activePage === i}>
                        {i + 1}
                    </Pagination.Item>
                )
            }
        }

        // Add Next and Last Buttons
        paginationItems.push(
            <Pagination.Next
                key="next"
                onClick={() => handlePageChange(activePage + 1)}
                disabled={activePage === totalPages - 1}
            />
        )
        paginationItems.push(
            <Pagination.Last
                key="last"
                onClick={() => handlePageChange(totalPages - 1)}
                disabled={activePage === totalPages - 1}
            />
        )

        return paginationItems
    }

    return (
        <div css={componentStyle}>
            <Loader show={fetchStatus === "loading" || contactFetchStatus === "loading"} />
            <AddEditAgency
                show={showAddAgency}
                hide={() => setShowAddAgency(false)}
                currentAgency={currentAgency}
                setCurrentAgency={setCurrentAgency}
                saveAgency={saveAgency}
            />
            <InformationModal
                show={showInformation.show}
                setShow={setShowInformation}
                information={showInformation.information}
            />
            <div
                className="page-container"
                style={{ marginTop: "80px" }}>
                <div className="d-flex justify-content-between align-items-center my-2">
                    <h2 className="pb-4">Agencies and Contacts</h2>
                    <Button
                        className="btn-sm"
                        variant="light"
                        onClick={() => {
                            setShowAddAgency(true)
                            setCurrentAgency({})
                        }}>
                        Add Agency
                    </Button>
                </div>

                <div className="bg-white p-3">
                    <div className="mb-2 row">
                        <div className="d-flex">
                            <div className="col-sm-2">
                                <Form.Control
                                    type="text"
                                    className="form-control-sm"
                                    placeholder="Search"
                                    name="searchAgencies"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <div>
                                <Form.Select
                                    name="searchIn"
                                    className="form-select-sm ms-2"
                                    value={searchIn}
                                    onChange={(e) => e.target.value && setSearchIn(e.target.value)}>
                                    <option value="Brokerage">Brokerage</option>
                                    <option value="BrokerContact">Contact</option>
                                </Form.Select>
                            </div>
                            <div className="col-2">
                                <button
                                    type="button"
                                    style={{ marginLeft: "15px" }}
                                    className="btn-sm select btn btn-primary"
                                    onClick={() => handleSearch(1)}>
                                    Search
                                </button>
                            </div>

                            <div className="ms-auto">
                                <button
                                    type="button"
                                    className="btn-sm btn btn-primary"
                                    onClick={() => handleExportAll()}>
                                    Export All
                                </button>
                            </div>
                        </div>
                    </div>
                    {agencies?.length === 0 && fetchStatus !== "loading" && (
                        <h4 className="text-center py-3">No Data Found</h4>
                    )}
                    {sectionsOpen.map((isOpen, index) => (
                        <div
                            key={index}
                            className="py-2 agencies-tab mt-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex flex-row">
                                    <div
                                        className="cursor-pointer"
                                        onClick={() => toggleSection(index)}
                                        style={{
                                            overflow: "hidden",
                                            height: "1.7em",
                                            marginRight: "2px"
                                        }}>
                                        <span className="site-tank-toggle ">
                                            {isOpen ? (
                                                <Image src={"/icons/down-arrow.svg"} />
                                            ) : (
                                                <Image src={"/icons/right-arrow.svg"} />
                                            )}
                                        </span>
                                        <strong>{agencies?.[index]?.name}</strong>
                                    </div>
                                    <div>
                                        {isOpen && (
                                            <>
                                                <Button
                                                    variant="light"
                                                    className="me-2 btn-sm"
                                                    onClick={() => handleEditAgency(agencies?.[index])}>
                                                    <FontAwesomeIcon
                                                        icon={byPrefixAndName.fal["pen-to-square"]}
                                                        style={{ color: "#000000" }}
                                                    />
                                                </Button>
                                                <Button
                                                    className="btn-sm"
                                                    variant="light"
                                                    onClick={() => {
                                                        setShowAddEditUser(true)
                                                        setCurrentUser({})
                                                        setContactAgencyId(agencies?.[index]?.id)
                                                    }}>
                                                    Add Contact
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <FontAwesomeIcon
                                    className="cursor-pointer"
                                    icon={byPrefixAndName.fal["circle-info"]}
                                    onClick={() => handleShowInformation(agencies?.[index]?.id, "agency")}
                                />
                            </div>

                            {isOpen && (
                                <UsersTable
                                    contacts={agencies?.[index]?.contacts}
                                    agencyId={agencies?.[index]?.id}
                                    agencies={agencies}
                                    setShowAddEditUser={setShowAddEditUser}
                                    showAddEditUser={showAddEditUser}
                                    setCurrentUser={setCurrentUser}
                                    currentUser={currentUser}
                                    handleShowInformation={handleShowInformation}
                                    getAgenciesList={getAgenciesList}
                                    contactAgencyId={contactAgencyId}
                                    setContactAgencyId={setContactAgencyId}
                                />
                            )}
                        </div>
                    ))}
                    {totalPages > 1 && (
                        <Pagination
                            className="mt-4 d-flex justify-content-end"
                            size="md">
                            {renderPagination()}
                        </Pagination>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AgenciesAndContact
